import React from "react";
import { Search, Globe2, ChevronRight, Star, CheckCircle } from "lucide-react";
import HorizontalSection from "./HorizontalSection";
import HeroSection from "./HeroSection";
import GlobalSearchBar from "./GlobalSearchBar";



export default function ProductLandingPage() {

   const handleSearch = (filters) => {
    console.log("User selected filters:", filters);};
  // Sample categories (later link to your 29 real ones)
  const categories = [
    { name: "Traders", icon: "📈" },
    { name: "Investors", icon: "💰" },
    { name: "Brokers", icon: "🏦" },
    { name: "Fintechs", icon: "💻" },
    { name: "Startups", icon: "🚀" },
    { name: "Analysts", icon: "🧠" },
    { name: "Educators", icon: "🎓" },
  ]; 

  // Sample card data
  const featured = [


    {
      title: "Capital.com",
      desc: "Award-winning CFD trading platform.",
      tier: "ROYAL",
      rating: 4.7,
      reviews: "20.3K",
      verified: true,
      image:
        "https://images.unsplash.com/photo-1611162616305-7e1d57486e69?w=600&q=80",
    },
    {
      title: "XM Markets",
      desc: "Forex and CFDs with tight spreads.",
      tier: "SILVER",
      rating: 4.3,
      reviews: "9.2K",
      verified: false,
      image:
        "https://images.unsplash.com/photo-1556742044-3c52d6e88c62?w=600&q=80",
    },

    {
  title: "TradeStation",
  desc: "Trusted U.S. broker offering ETFs and stocks.",
  tier: "PLATINUM",
  rating: 4.8,
  reviews: "15.6K",
  verified: true,
  country: "United States",
  online: true,
  image: "https://images.unsplash.com/photo-1567427017947-545c5f8d16ad?w=600&q=80",
},
{
  title: "easyMarkets",
  desc: "Global forex platform since 2001.",
  tier: "GOLD",
  rating: 4.5,
  reviews: "12K",
  verified: true,
  country: "Cyprus",
  online: false,
  image: "https://images.unsplash.com/photo-1620138546264-1f6a6e1a9a90?w=600&q=80",
},

  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-black text-white">
      <HeroSection />
      <div className="absolute top-[60vh] w-full">
        <GlobalSearchBar onSearch={handleSearch} />
      </div>
      {/* Header */}
      <header className="sticky top-0 z-40 bg-slate-950/80 backdrop-blur-xl border-b border-slate-800">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
          <div className="flex items-center gap-2">
            <img src="/logo192.png" alt="M2T Logo" className="w-8 h-8" />
            <span className="font-bold text-lg bg-gradient-to-r from-yellow-300 to-orange-500 bg-clip-text text-transparent">
              Million2Trillion
            </span>
          </div>
          
          {/* Search bar */}
          <div className="flex items-center gap-2 bg-slate-800/60 rounded-full px-4 py-2 w-[420px] max-w-full">
            <Search className="w-4 h-4 text-slate-400" />
            <input
              type="text"
              placeholder="Search verified professionals, brokers, or startups..."
              className="bg-transparent outline-none text-sm text-white w-full"
            />
          </div>

          <div className="flex items-center gap-3 text-sm text-slate-300">
            <button className="hover:text-white">Become a Partner</button>
            <Globe2 className="w-5 h-5" />
            <button className="bg-gradient-to-r from-purple-600 to-blue-500 px-4 py-1 rounded-full font-medium hover:opacity-90">
              Login / Signup
            </button>
          </div>
        </div>
      </header>

      {/* Categories scroller */}
      <section className="overflow-x-auto whitespace-nowrap py-4 border-b border-slate-800">
        <div className="max-w-7xl mx-auto flex gap-5 px-6">
          {categories.map((cat, i) => (
            <button
              key={i}
              className="inline-flex items-center gap-2 bg-slate-800/60 hover:bg-slate-700 px-4 py-2 rounded-full text-sm transition"
            >
              <span>{cat.icon}</span> {cat.name}
            </button>
          ))}
        </div>
      </section>

      {/* Hero Section */}
      <section className="text-center py-12">
        <h1 className="text-4xl sm:text-5xl font-extrabold mb-3 text-blue-400">
          Verified Market Network for Every Role
        </h1>
        <p className="text-slate-400 max-w-2xl mx-auto text-sm sm:text-base">
          Discover verified brokers, traders, investors, fintechs and educators
          — all connected under one SmartCard-powered ecosystem.
        </p>
      </section>

      {/* Featured Sections */}
{/* Horizontal sections */}
<main className="max-w-7xl mx-auto px-6 space-y-12 pb-16">
  <HorizontalSection title="🌍 Top Verified Brokers" data={featured} />
  <HorizontalSection title="🔥 Top Traders" data={featured} />
  <HorizontalSection title="🚀 Trending Fintechs" data={featured} />

  {/* CTA */}
  <section className="text-center bg-gradient-to-r from-blue-600/30 to-purple-600/30 border border-slate-700 rounded-2xl p-10 mt-10">
    <h2 className="text-3xl font-bold mb-2">
      Ready to Get Your SmartCard?
    </h2>
    <p className="text-slate-300 mb-4 text-sm">
      Join the world’s first verified financial ecosystem.
    </p>
    <button className="bg-gradient-to-r from-purple-500 to-blue-500 px-6 py-2 rounded-full font-semibold hover:opacity-90">
      Join Now for Free
    </button>
  </section>
</main>


      {/* Footer */}
      <footer className="border-t border-slate-800 mt-12 py-8 text-center text-slate-400 text-xs">
        <div className="mb-3">
          Million2Trillion © {new Date().getFullYear()} — All Rights Reserved.
        </div>
        <div className="flex justify-center gap-4 text-sm">
          <a href="#" className="hover:text-white">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-white">
            Terms of Service
          </a>
          <a href="#" className="hover:text-white">
            Contact
          </a>
        </div>
      </footer>
    </div>
  );
}
